import React, { useEffect, useState } from "react";
import "./gAutomationTooltip.css";
import { useSelector } from "react-redux";

const Sidebar = ({ navigationTabs = [], step, setStep }) => {
  const [currentActiveStep, setCurrentActiveStep] = useState(step);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { formValidStatusData: formStatus } = useSelector((state) => state.api); // Updated selector

  const handleStepClick = (stepNumber) => {
    if (
      (stepNumber >= 2 && !formStatus.isFormOneValid) ||
      (stepNumber >= 3 && !formStatus.isFormTwoValid) ||
      (stepNumber >= 4 && !formStatus.isFormThreeValid) ||
      (stepNumber >= 5 && !formStatus.isFormFourValid)
    )
      return false;
    setCurrentActiveStep(stepNumber);
    setStep(stepNumber);
  };
  useEffect(() => {
    setCurrentActiveStep(step);
  }, [step]);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className={`left-sidebar ${isCollapsed ? "left-collapsed" : ""}`}>
        {navigationTabs?.map(({ number, title, subTexts, bullet }) => (
          <div
            key={number}
            className={`${
              (number >= 2 && !formStatus.isFormOneValid) ||
              (number >= 3 && !formStatus.isFormTwoValid) ||
              (number >= 4 && !formStatus.isFormThreeValid) ||
              (number >= 5 && !formStatus.isFormFourValid)
                ? " stepNonClick "
                : (number == 1 && !formStatus.isFormOneValid) ||
                  (number <= 2 && formStatus.isFormOneValid) ||
                  (number <= 3 && formStatus.isFormTwoValid) ||
                  (number <= 4 && formStatus.isFormThreeValid) ||
                  (number <= 5 && formStatus.isFormFourValid)
                ? " step "
                : " stepNonClick "
            } ${currentActiveStep === number ? " step-active  " : ""} `}
            onClick={() => handleStepClick(number)}
          >
            {bullet !== false && <div className="step-number">{number}</div>}
            {!isCollapsed && (
              <div className="step-content">
                <h3>{title}</h3>
                <div className="sub-text-container">
                  {subTexts?.map((text, index) => (
                    <p key={index} className="sub-text">
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* <button className="toggle-btn" onClick={toggleSidebar}>
        {isCollapsed ? (
          <svg
            className="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m9 5 7 7-7 7"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m15 19-7-7 7-7"
            />
          </svg>
        )}
      </button> */}
    </div>
  );
};

export default Sidebar;
